import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Instructor Dashboard -> "Report a Vehicle Issue" dialog. Extracted from
// InstructorDashboard.js (props-driven, no behavior change).
export const VehicleIssueDialog = ({ open, onOpenChange, vehicles, form, onFormChange, onPhotoChange, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="vehicle-issue-dialog">
      <DialogHeader>
        <DialogTitle>Report a Vehicle Issue</DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        <div className="space-y-1.5">
          <Label>Vehicle</Label>
          <select
            className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm"
            value={form.vehicle_id}
            onChange={(e) => onFormChange((f) => ({ ...f, vehicle_id: e.target.value }))}
            data-testid="vehicle-issue-vehicle-select"
          >
            <option value="">Select a vehicle</option>
            {vehicles.map((v) => (
              <option key={v.id} value={v.id}>
                {v.make} {v.model} - {v.license_plate}
              </option>
            ))}
          </select>
        </div>
        <div className="space-y-1.5">
          <Label>Description</Label>
          <Textarea
            placeholder='e.g. "Brake warning light came on"'
            value={form.description}
            onChange={(e) => onFormChange((f) => ({ ...f, description: e.target.value }))}
            data-testid="vehicle-issue-description-input"
          />
        </div>
        <div className="space-y-1.5">
          <Label>Priority</Label>
          <select
            className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm"
            value={form.priority}
            onChange={(e) => onFormChange((f) => ({ ...f, priority: e.target.value }))}
            data-testid="vehicle-issue-priority-select"
          >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>
        </div>
        <div className="space-y-1.5">
          <Label>Photos (optional)</Label>
          <Input type="file" accept="image/*" multiple onChange={onPhotoChange} data-testid="vehicle-issue-photo-input" />
          {form.photos.length > 0 && (
            <div className="flex gap-2 flex-wrap pt-1">
              {form.photos.map((p) => (
                <img key={p.uid} src={p.data} alt="issue" className="h-14 w-14 rounded object-cover border" />
              ))}
            </div>
          )}
        </div>
      </div>
      <DialogFooter>
        <Button onClick={onSubmit} data-testid="vehicle-issue-submit-button">Submit Issue</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
